module.exports = __webpack_public_path__ + "static/media/Easter_RewardBackground.cfe10826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Easter_RewardBackground.png
// module id = 1356
// module chunks = 3